module.exports = __webpack_public_path__ + "static/media/clock.586ffd26.svg";